import { useSelector } from 'react-redux'
import { LoadingTypes } from '../../modules/loading/reducer'
import { isLoading } from '../../utils/loadingState'
import { useUserType } from '../../utils/hooks/useUserType'
import { AzureAccountRegistration } from './AzureAccountRegistration/AzureAccountRegistration'
import { useCloudSettingsAccountId } from './useCloudSettingsAccountId'
import type { CloudSettingsState } from './cloudSettingsState'

const AzureCloudSettings = () => {
  const userType = useUserType()
  const productType = 'oppsync'
  const accountId = useCloudSettingsAccountId({ product: 'oppsync' })

  const isLoadingAccounts = useSelector((state: CloudSettingsState) =>
    isLoading(state.loading)(LoadingTypes.CMCM_FETCHING_ACCOUNTS)
  )

  if (!accountId) {
    return <></>
  }

  return !isLoadingAccounts ? (
    <AzureAccountRegistration
      productType={productType}
      partnerType={userType}
    />
  ) : (
    <></>
  )
}

export default AzureCloudSettings
